import React, { FC, useContext } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Stack } from '../stack/Stack';
import { Typography } from '../typography/Typography';
import { TwoColumnContext } from '../../context/TwoColumnContext';
import { Html } from '../html/Html';
import { createMarkup } from '../../utils/createMarkup';
import tokens from './tokens';

// Interface

export interface TitleBlockProps {
  heading: string;
  description?: string;
  forceNotCentered?: boolean;
}

export interface StyledTitleBlockProps {
  centered?: boolean;
  constrain?: boolean;
  forceNotCentered?: boolean;
}

export const StyledTitleBlock = styled(Stack)<StyledTitleBlockProps>`
  ${({ theme: { media }, centered, forceNotCentered }) => css`
    text-align: ${centered ? 'center' : 'left'};

    @media (min-width: ${media.medium}) {
      max-width: 90%;
      margin-left: ${centered && !forceNotCentered ? 'auto' : '0'};
      margin-right: ${centered && !forceNotCentered ? 'auto' : '0'};

      h2,
      p {
        text-wrap: balance;
      }
    }
  `}
`;

// JSX

export const TitleBlock: FC<TitleBlockProps> = ({
  heading,
  description,
  forceNotCentered,
}) => {
  const isInTwoColumnLayout = useContext(TwoColumnContext);
  return (
    <StyledTitleBlock
      gap="small"
      centered={!isInTwoColumnLayout && !forceNotCentered}
      constrain={!isInTwoColumnLayout}
    >
      {heading && (
        <Typography
          component={tokens.headingcomponent}
          variant={tokens.headingVariant}
        >
          {heading}
        </Typography>
      )}
      {description && (
        <Typography component="p" variant={tokens.descriptionVariant}>
          {description && typeof description === 'string'
            ? createMarkup(description)
            : description}
        </Typography>
      )}
    </StyledTitleBlock>
  );
};

export default TitleBlock;
